import { defineMessages } from 'react-intl-next';

export default defineMessages({
	expandIconLabel: {
		id: 'ai-mate.chat-history.loading-state.expand-icon',
		defaultMessage: 'Expand',
		description: 'Label for chevron-right icon',
	},
	collapseIconLabel: {
		id: 'ai-mate.chat-history.loading-state.collapse-icon',
		defaultMessage: 'Collapse',
		description: 'Label for chevron-down icon',
	},
});
